<script>
    import PageFooter from "./components/PageFooter.svelte";
    import PageHeader from "./components/PageHeader.svelte";
    import Router from "./routes/Router.svelte";

    import { initialiseAnalytics } from './analytics'
    import { projectSettings } from './config'

    export let url = "";

    const basepath = window.basePath || '/';

    const disableSubmitOnEnter = (e) => {
        if (e.which != '13') return;

        if (e.target && e.target.type && e.target.type != "textarea") {
            e.preventDefault();
        }
    }

    initialiseAnalytics();

</script>

<div class="page" on:keypress={(e) => disableSubmitOnEnter(e)}>
    <PageHeader></PageHeader>

    <main>
        <section>
            <div class="form-content container-fluid">
                <form novalidate autocomplete="off">
                    <Router {url} {basepath}></Router>
                </form>
            </div>
        </section>
    </main>
</div>

<PageFooter></PageFooter>

<style>
    
    :global(hr.primary) {
        border-top: 2px solid var(--color-primary);
        margin: 16px auto;
        opacity: 1;
    }

    .page section {
        width: 100%;
        padding: var(--spacing-section) 0;
        padding: 40px 0;
        background-color: var(--color-lightGrey);
        position: relative;
        z-index: 1
    }

    .form-content {
        max-width: 1210px;
        width: 100%;
        max-width: 1440px;
        padding: 0px 30px;
        margin: 0px auto;
    }
    
    @media print {
        .page section {
            padding: 0;
        }
}

</style>